import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import getters from './getters'
import config from '../common/config';
import session from './modules/session';
import createPersistedState from 'vuex-persistedstate';
import createLogger from 'vuex/dist/logger';
import CFHttpCfg from '../base/cf/CFHttpCfg'

Vue.use(Vuex)
var plugins = config.isDebug ? [createLogger()] : [];

plugins.push(createPersistedState());
const store = new Vuex.Store({
  modules: {
    app,
    session,
    user
  },
  strict: config.isDebug,
  plugins: plugins,
  getters,
  mutations: {
      saveTagsData(state, data) {
        state.tagsStoreList = data;
        sessionStorage.setItem("Tags"+cf.session.userId,data)
    },
},
})

export default store
